import './SectionTiles.scss';

import React           from 'react';
import useDesignTokens from '@/hooks/useDesignTokens';

export default function SectionTiles<T extends string>({ value, onChange, options }: {
	value: T;
	onChange: (value: T) => void;
	options: { value: T; label: string; icon: React.ReactNode; className?: string; }[];
}) {
	const tokens = useDesignTokens();

	return (
		<div
			role="tablist"
			className="section-tiles"
			style={{
				'--section-tiles-border': tokens.border.default,
				'--section-tiles-active-bg': `color-mix(in srgb, ${tokens.color.primary} 10%, transparent)`,
				'--section-tiles-active-color': tokens.color.primary,
				'--section-tiles-color': tokens.text.muted,
				'--section-tiles-hover-color': tokens.text.default,
				'--section-tiles-hover-bg': tokens.surface.subtle,
			} as React.CSSProperties}
		>
			{options.map(option => {
				const active = option.value === value;

				return (
					<button
						key={option.value}
						type="button"
						role="tab"
						aria-selected={active}
						className={['section-tiles__tab', active && 'section-tiles__tab--active', option.className].filter(Boolean).join(' ')}
						onClick={() => onChange(option.value)}
					>
						<span className="section-tiles__icon">{option.icon}</span>
						<span className="section-tiles__label" data-label={option.label}>{option.label}</span>
					</button>
				);
			})}
		</div>
	);
}
